export const FEATURE_CARDS = [
    {
        title: "Clear Communication",
        description: "Honest, proactive updates.",
        icon: "ti-comments"
    },
    {
        title: "Ownership Mindset",
        description: "Treats your product as my own.",
        icon: "ti-heart"
    },
    {
        title: "Calm Handling",
        description: "Navigates complex codebases.",
        icon: "ti-book"
    },
    {
        title: "Reliability",
        description: "Consistent delivery in critical phases.",
        icon: "ti-shield"
    }
];


